import React from "react"

const Splash = ({ error }) => (
  <div className="splash">
    {!error ? <p>Studio Flux</p> : error.toString()}
  </div>
)

export default Splash
